import axios from 'axios'
import Vue from 'vue'
import { version } from '../../package.json'

export default {
  getAllDataBotConfiguration (idBot) {
    return axios.get(`${Vue.prototype.$globalConst.SERVICE_CHANNEL}/peoplechat/${idBot}`, { headers: { version } })
  }
}
